import React from 'react'
import PropTypes from 'prop-types';
import FormControlTemplate from '../ui/formControlTemplate/FormControlTemplate.js';

const Label = React.lazy(() => import('../ui/label/Label'));
const Dropdown = React.lazy(() => import('../ui/inputs/dropdown/DropDown'));
const ValidationText = React.lazy(() => import('../ui/validation/ValidationText.js'))

const FormSelectField = ({
  keyId,
  dataField,
  labelName,
  value,
  error,
  formSetting,
  overRideProps,
  isRequired,
  fieldSetting,
  onChange,
  onBlure,
  onActionChange,
  ...otherProps
}) => {

  const handleChange = (selectedOption) => {
    if (onChange) {
      if (fieldSetting?.isMultiSelect) {
        const selectedValues = selectedOption.map((option) => option.value);
        onChange(dataField, selectedValues)
      }
      else {
        onChange(dataField, selectedOption);
      }
    }
  }
  const handleOnBlur = () => {
    onBlure?.(dataField)
  };

  const handleButtonClick = (action) => {
    onActionChange(action, dataField);
  };
  

  return (
    <div className='dropdown-label'>
      <div className='input-label-part'>
        {labelName && labelName !== "" && (
          <Label labelName={labelName} isRequired={isRequired} />
        )}
        {fieldSetting?.subTitle ?
          <div className={`"section-title" `}>
            <h5>{fieldSetting.subTitle}</h5>
          </div>
          : ""}
        <Dropdown
          keyId={keyId}
          placeholder={fieldSetting?.placeholder}
          onChange={handleChange}
          onBlur={handleOnBlur}
          options={fieldSetting?.options}
          value={value}
          isMultiSelect={fieldSetting?.isMultiSelect}
          isDisabled={formSetting?.isViewOnly || (overRideProps?.isDisable !== false && fieldSetting?.isDisable) || false}
          inputInfoConfig={fieldSetting?.inputInfoConfig}
          isLoading={fieldSetting?.isLoading}
          {...otherProps}
        />
        {fieldSetting?.isFormControl &&
          <FormControlTemplate
            fieldSetting={fieldSetting}
            handleButtonClick={handleButtonClick}
          />
        }
      </div>
      <ValidationText error={error || ""} />
    </div>
  )
}

FormSelectField.propTypes = {
  keyId: PropTypes.string.isRequired,
  dataField: PropTypes.string.isRequired,
  labelName: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.string,
  formSetting: PropTypes.shape({
    isViewOnly: PropTypes.bool,
  }),
  overRideProps: PropTypes.shape({
    isDisable: PropTypes.bool,
  }),
  isRequired: PropTypes.bool,
  fieldSetting: PropTypes.shape({
    isMultiSelect: PropTypes.bool,
    placeholder: PropTypes.string,
    options: PropTypes.array,
    isDisable: PropTypes.bool,
    subTitle: PropTypes.string,
    isFormControl: PropTypes.bool,
    inputInfoConfig: PropTypes.object,
    isLoading:PropTypes.bool,
  }),
  onChange: PropTypes.func.isRequired,
  onBlure: PropTypes.func,
  onActionChange: PropTypes.func,
};

export default FormSelectField;